<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateContenidoEntregable"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetSendingOfDeliverablesModalEdit.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="entregable.entregable.asunto"
          :inputError="$v.entregable.entregable.asunto.$error"
          :label="$t('mEditionAssetSendingOfDeliverablesModalEdit.inputs.asunto.label')"
          :message="$t('mEditionAssetSendingOfDeliverablesModalEdit.inputs.asunto.message')"
          :messageError="messageErrorAsunto"
          name="asunto"
          type="text"
          @blur="$v.entregable.entregable.asunto.$touch()"
        />

        <AtomTextAreaPrimary
          v-model="entregable.entregable.mensaje"
          :inputError="$v.entregable.entregable.mensaje.$error"
          :label="$t('mEditionAssetSendingOfDeliverablesModalEdit.inputs.mensaje.label')"
          :messageError="messageErrorMensaje"
          name="mensaje"
          rows="8"
          @blur="$v.entregable.entregable.mensaje.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetSendingOfDeliverablesModalEdit.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'mEditionAssetSendingOfDeliverablesModalEdit',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetSendingOfDeliverablesModalEdit.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      entregable: {
        academia: '',
        entregable: {
          asunto: '',
          mensaje: '',
          dia: ''
        }
      }
    }
  },

  validations: {
    entregable: {
      entregable: {
        asunto: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        },

        mensaje: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorAsunto () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesModalEdit', this.$v.entregable.entregable.asunto, 'asunto')
    },

    messageErrorMensaje () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesModalEdit', this.$v.entregable.entregable.mensaje, 'mensaje')
    }
  },

  created () {
    this.entregable.academia = this.$store.getters.getAcademyData.id
    this.entregable.entregable.mensaje = this.$modal.element.entregable.mensaje
    this.entregable.entregable.asunto = this.$modal.element.entregable.asunto
    this.entregable.entregable.dia = this.$modal.element.entregable.dia
  },

  methods: {
    updateContenidoEntregable () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('contenido', 'updateContenidoEntregable', this.entregable, [this.$modal.element.entregable.id])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalEdit', 'updateContenidoEntregable', 'success')
            this.buttonPrimary.sending = false
            this.$modal.closeModal()
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalEdit', 'updateContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
